const SUFFIXES = ["th", "st", "nd", "rd"];

export const formatOrdinal = (value: number) => {
  const remainder = value % 100;
  const suffix = SUFFIXES[(remainder - 20) % 10] ?? SUFFIXES[remainder] ?? SUFFIXES[0];

  return `${value}${suffix}`;
};
